<template>
  <div>
    <template v-if="!isLoggedIn && !loginInProgress">
      <v-btn
        icon
        @click="
          showDialog = true;
          loginInProgress = true;
        "
        v-tooltip.bottom-end="$t('profile.name')"
      >
        <v-icon :class="size">mdi-account-off</v-icon>
      </v-btn>

      <login-dialog v-model:show="showDialog" @loggedIn="loginInProgress = false"></login-dialog>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import LoginDialog from '@/venit/components/cortona-venit/components/login/LoginDialog.vue';
import { useAccountStore } from '@/stores/account';

withDefaults(defineProps<{
  size?: string;
}>(), {
  size: 'large',
});

const accountStore = useAccountStore();

const showDialog = ref(false);
const loginInProgress = ref(false);

const isLoggedIn = computed(() => accountStore.authenticated);
</script>

<style scoped>
.large {
  font-size: 36px !important;
}

.medium {
  font-size: 24px !important;
}
</style>